import React from 'react';
import { Box } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const ProCrownIcon = ({ size = 22, titleAccess }) => {
  const badgeSize = Math.round(size + 4);

  return (
    <Box
      component="span"
      sx={{
        width: badgeSize,
        height: badgeSize,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: BRAND.accent,
        color: BRAND.onAccent,
        boxShadow: `0 0 0 1px ${BRAND.surface}`,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        aria-hidden={!titleAccess}
        role={titleAccess ? 'img' : 'presentation'}
      >
        {titleAccess ? <title>{titleAccess}</title> : null}
        <path
          d="M4.2 9.1 7.4 13l4.6-6.4 4.6 6.4 3.2-3.9v8.6H4.2V9.1Z"
          fill="currentColor"
        />
        <path d="M4.2 16.2h15.6v2.2H4.2z" fill="currentColor" opacity="0.72" />
        <circle cx="4.4" cy="8.2" r="1.45" fill="currentColor" />
        <circle cx="12" cy="5.4" r="1.7" fill="currentColor" />
        <circle cx="19.6" cy="8.2" r="1.45" fill="currentColor" />
      </svg>
    </Box>
  );
};

export default ProCrownIcon;
